import { useCallback, useRef } from 'react';

export function useApi() {
  const abortControllersRef = useRef(new Set());

  const request = useCallback(async (path, options = {}) => {
    const controller = new AbortController();
    abortControllersRef.current.add(controller);

    try {
      const response = await fetch(path, {
        ...options,
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(options.headers || {}),
        },
      });

      if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(`HTTP ${response.status}${text ? `: ${text}` : ''}`);
      }

      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        return await response.json();
      }
      return await response.text();
    } finally {
      abortControllersRef.current.delete(controller);
    }
  }, []);

  const get = useCallback((path, params) => {
    let url = path;
    if (params && Object.keys(params).length > 0) {
      const query = new URLSearchParams(params).toString();
      url = `${path}?${query}`;
    }
    return request(url, { method: 'GET' });
  }, [request]);

  return { request, get };
}
